import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useFetch } from '../../hooks/useFetch';
import { pagesApi } from '../../api/pagesApi';
import { SiteLogo } from '../ui/SiteLogo';
import './Header.css';

const LIENS_FIXES = [
  { to: '/particuliers', label: 'Particuliers' },
  { to: '/professionnels', label: 'Professionnels' },
  { to: '/blog', label: 'Blog' },
  { to: '/a-propos', label: 'À propos' },
  { to: '/contact', label: 'Contact' },
];

const SLUGS_FIXES = new Set(LIENS_FIXES.map((l) => l.to.replace(/^\//, '')));

export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { data: pages } = useFetch(() => pagesApi.list(), []);

  // Une page CMS (ex: "À propos") peut déjà être couverte par un lien fixe ci-dessus :
  // on l'exclut de l'injection dynamique pour ne jamais créer de doublon dans le menu,
  // même si "Afficher dans le menu principal" est coché en back-office pour cette page.
  const liensPages = (pages || [])
    .filter((p) => p.afficher_menu && !SLUGS_FIXES.has(p.slug))
    .map((p) => ({ to: `/${p.slug}`, label: p.menu_label || p.titre }));

  const LIENS = [...LIENS_FIXES, ...liensPages];

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className="site-header">
      <Link to="/" className="site-header__logo">
        <SiteLogo tone="clair" height={44} />
      </Link>

      <nav className="site-header__nav">
        {LIENS.map((lien) => (
          <Link key={lien.to} to={lien.to}>
            {lien.label}
          </Link>
        ))}
      </nav>

      <Link to="/devis" className="site-header__cta">
        Demander un devis
      </Link>

      <button
        type="button"
        className="site-header__burger"
        onClick={() => setOpen(true)}
        aria-label="Ouvrir le menu"
        aria-expanded={open}
      >
        <Menu size={24} />
      </button>

      <div className={`site-header__mobile ${open ? 'site-header__mobile--open' : ''}`}>
        <div className="site-header__mobile-top">
          <span className="site-header__logo">
            <SiteLogo tone="clair" height={36} />
          </span>
          <button
            type="button"
            className="site-header__burger"
            onClick={() => setOpen(false)}
            aria-label="Fermer le menu"
          >
            <X size={24} />
          </button>
        </div>

        <nav className="site-header__mobile-nav">
          {LIENS.map((lien) => (
            <Link key={lien.to} to={lien.to}>
              {lien.label}
            </Link>
          ))}
        </nav>

        <Link to="/devis" className="site-header__cta site-header__cta--mobile">
          Demander un devis
        </Link>
      </div>
    </header>
  );
}
